import { render, staticRenderFns } from "./StandardFormRow.vue?vue&type=template&id=0bd2d16b&scoped=true&"
import script from "./StandardFormRow.vue?vue&type=script&lang=js&"
export * from "./StandardFormRow.vue?vue&type=script&lang=js&"
import style0 from "./StandardFormRow.vue?vue&type=style&index=0&id=0bd2d16b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd2d16b",
  null
  
)

export default component.exports